import {Determinant} from "./determinant";

export class BooleanDeterminant extends Determinant {

  public booleanValue: boolean;

}
